<template>
    <form class="form-wrapper">
        <div class="form-wrapper-body">
            <h3 class="form-wrapper-body-title">Choose filters</h3>

            <div class="mt-3">
                <div class="label mb-1">Status</div>
                <select-box :data-list="statuses" :required="true" @selected="onStatusSelect" :default-value="status"
                    :format-callback="item => capitalize(item)" />
            </div>

        </div>
        <div class="form-wrapper-footer">
            <button :class="['form-wrapper-footer-button', 'primary-btn', 'btn-center']" 
            :style="{ marginRight: '1rem'}"
            @click.prevent="submit">
                Apply
            </button>
            <button :class="['form-wrapper-footer-button', 'danger-btn', 'btn-center']" @click.prevent="reset">
                Clear all
            </button>
        </div>
    </form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { GetUserInfoFromLocalStorage } from '@/mixins/GetUserInfoFromLocalStorage';
import { FormMixin } from '@/mixins/FormMixin';

export default {
    name: 'ChangePasswordModal',

    components: {
        SelectBox: () => import("@/components/controls/SelectBox"),
    },

    data() {
        return {
            selectedStatus: null,
            statuses: [
                'draft',
                'open',
                'paid',
                'past_due',
                'void',
                'uncollectible',
            ]
        }
    },
    computed: {
        ...mapGetters(['modalFilters']),
        status() {
            return this.modalFilters && this.modalFilters.invoiceStatus;
        },
    },
    methods: {
        ...mapActions(['closeModal', 'setModalFilters', 'resetModalFilters', 'getReceipts']),
        onStatusSelect(status) {
            this.selectedStatus = status;
            this.setModalFilters({ ...this.filters, invoiceStatus: this.selectedStatus });
        },
        capitalize: function (value) {
            if (value === 'past_due') {
                return 'Past Due';
            } else {
                return _.capitalize(value);
            }
        },
        submit() {

            try {

                if (!this.selectedStatus) {
                    return;
                }
                this.setModalFilters({ ...this.filters, invoiceStatus: this.selectedStatus });
                this.getReceipts();
                this.closeModal();
            } finally {

            }
        },
        reset() {
            this.selectedStatus = null;
            this.resetModalFilters();
            this.getReceipts();
            this.closeModal();
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/modals/FilterReceiptsModal.vue